import destinationIconUrl from '@assets/svg/destinationPin.svg';
import lastLocationIconUrl from '@assets/svg/lastLocation.svg';
import occurrenceUrl from '@assets/svg/occurrence.svg';
import occurrenceResolvedUrl from '@assets/svg/occurrenceResolved.svg';
import originIconUrl from '@assets/svg/originPin.svg';
import * as leaflet from 'leaflet';

export const iconsLocations = {
  origin: new leaflet.Icon({
    iconUrl: originIconUrl,
    iconSize: [10, 10.09],
    iconAnchor: [5, 5.045],
  }),
  lastLocation: new leaflet.Icon({
    iconUrl: lastLocationIconUrl,
    iconSize: [52, 52.48],
    iconAnchor: [26, 26.24],
  }),
  destination: new leaflet.Icon({
    iconUrl: destinationIconUrl,
    iconSize: [16, 16.15],
    iconAnchor: [8, 8.075],
  }),
  occurrence: new leaflet.Icon({
    iconUrl: occurrenceUrl,
    iconSize: [43, 46],
    iconAnchor: [21.5, 46],
  }),
  occurrenceResolved: new leaflet.Icon({
    iconUrl: occurrenceResolvedUrl,
    iconSize: [43, 46],
    iconAnchor: [21.5, 46],
  }),
};
